export type PublicationTestType =
  | 'EPHEMERIDE'
  | 'WEATHER'
  | 'ETS_PROFILE'
  | 'WELCOME'
  | 'ANNIVERSARY'
  | 'DAY_MENU'
  | 'TEXT_ONLY'
  | 'ONE_IMAGE'
  | 'TWO_IMAGES'
  | 'THREE_IMAGES';
